import request from '../utils/request';

// 团体邀请列表查询
export function getLists(data) {
  let formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return request({
    url: '/frontExhibitor/populationInvite/groupInviteListView',
    method: 'post',
    data: formData,
  });
}
// 新增买家;

export function addAudience(data) {
  return request({
    url: '/frontExhibitor/populationInvite/appendAudience',
    method: 'post',
    data: data,
  });
}

// 获取单个获取当前买家信息
export function getItem(data) {
  return request({
    url: '/frontExhibitor/populationInvite/getEditAudience',
    method: 'post',
    params: data,
  });
}

// 修改买家信息
export function editItem(data) {
  return request({
    url: '/frontExhibitor/populationInvite/saveEditAudience',
    method: 'post',
    data: data,
  });
}

// 删除买家
export function delItem(data) {
  return request({
    url: '/frontExhibitor/populationInvite/deleteAudience',
    method: 'post',
    params: data,
  });
}

// 提交买家
export function submitList(data) {
  return request({
    url: '/frontExhibitor/populationInvite/commitAudience',
    method: 'post',
    data: data,
  });
}